import BaseOption from "%/dynamic-component-editor/classes/base-option";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";

export default class StartCallText extends BaseOption {
  static label = "Start Text";
  static userInterfaceComponent = {
    component: inspectorTools.SIMPLE_INPUT,
  };
  static defaultValue = "Start call";
}
